var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('resource',{attrs:{"resource":"circularMail","resourceName":"Rundmail","withFiles":true,"original":_vm.original,"attributes":[
      {
        name: 'support_profile',
        label: 'Support-Profile',
        type: 'CheckboxSelector',
        value: false
      },
      {
        name: 'sender_id',
        label: 'Absender',
        type: 'DropdownProfileSelector',
        resource: 'customerProfile',
        hideable: true,
        hideEvent: 'support-profile',
        appends: ['primaryImage'],
        filter: [
          {
            name: 'fake'
          },
          {
            name: 'sort',
            mode: 'ASC',
            attribute: 'name'
          },
          {
            name: 'forSelect'
          },
          {
            name: 'withoutTrashed'
          },
          {
            name: 'select',
            value: ['name', 'id']
          }
        ]
      },
      {
        name: 'circular_mail_messages',
        label: 'Nachrichtenelemente',
        type: 'MessageElementsSelector'
      },
      {
        name: 'send_at',
        label: 'Versenden am',
        type: 'DateTimeSelector',
        value: null
      },

      {
        name: 'age',
        label: 'Alter',
        type: 'MultiSliderSelector',
        max: 125,
        min: 18,
        isFilter: true
      },
      {
        name: 'send_to_gender',
        label: 'Geschlecht',
        type: 'SexSelector',
        multiSelect: true,
        isFilter: true
      },
      {
        name: 'photo',
        label: 'Foto',
        type: 'OptionSelector',
        isFilter: true
      },
      {
        name: 'registered_from',
        label: 'Registriert von',
        type: 'DateSelector',
        isFilter: true
      },
      {
        name: 'registered_to',
        label: 'Registriert bis',
        type: 'DateSelector',
        isFilter: true
      },
      {
        name: 'max_days_offline',
        label: 'Tage letzter Login',
        type: 'UserActivitySelector',
        max: _vm.circularmailOfflineDays,
        min: 0,
        isFilter: true
      },
      {
        name: 'transaction',
        label: 'Käufe',
        type: 'OptionSelector',
        isFilter: true
      },
      {
        name: 'spent',
        label: _vm.spendLabel,
        type: 'number',
        isFilter: true
      }
    ]},on:{"attributes-changed":_vm.updateTable}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Rundmail Bearbeiten")])])]),_vm._v(" "),(_vm.showTable)?_c('v-table',{ref:"filterDetailsTable",attrs:{"id":"filterDetailsTable","url":"/api/v1/circularMail/profile-filter-details","filter":_vm.tableFilter,"additionalRequestData":_vm.circularMailAttributes,"attributes":[
      {
        attribute: 'name',
        name: 'Name'
      },
      {
        attribute: 'value',
        name: 'Anzahl'
      }
    ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n      Benutzeranzahl, die angeschrieben werden ("+_vm._s(_vm.tableCount)+")\n    ")]),_vm._v(" "),_c('tr',{attrs:{"slot":"bottom"},slot:"bottom"},[_c('td',[_c('strong',[_vm._v("\n          Gesamt\n        ")])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v("\n          "+_vm._s(_vm.tableCount)+"\n        ")])])])]):_vm._e(),_vm._v(" "),(_vm.showTable)?_c('v-table',{ref:"table",attrs:{"url":"/api/v1/circularMail/filtered-profiles","filter":_vm.tableFilter,"additionalRequestData":_vm.circularMailAttributes,"attributes":[
      {
        attribute: 'id',
        name: 'ID'
      },
      {
        type: 'LinkProfileCell',
        name: 'Kunde'
      },
      {
        attribute: 'created_at',
        name: 'Angelegt am',
        type: 'DateCell'
      }
    ]}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }